export const WalletMode = {
    LOGOUT : -1,
    NONE : 0,
    USER : 1,
    STORE : 2
};

export const contractAddress = "0x1560Cb1E8918E7fB369fb623a1b628637Cca22e5";

// export const gatewayAddress = "https://harlequin-adverse-quelea-169.mypinata.cloud/ipfs/"
export const gatewayAddress = "https://tan-casual-dog-715.mypinata.cloud/ipfs/"
export const gatewayToken = "INcIawltcOkj6tfO64Ul0dkF4bYwqO23m_FZXIH-ZmmO9tVQhBh5Oafd_FmQe_5P"

export const pageBackgroundColor = "#F8E8EE"